import * as React from 'react';

interface IconProps {
	isHovered: boolean;
}

export function GaugeIcon({ isHovered }: IconProps) {
	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<path
					d='m12 14 4-4'
					style={{
						transformOrigin: '12px 14px',
						transform: isHovered ? 'rotate(45deg)' : 'rotate(0deg)',
						transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
					}}
				/>
				<path d='M3.34 19a10 10 0 1 1 17.32 0' />
			</svg>
		</div>
	);
}
